// Action Types
export const LOAD_AUTH_USER = "bonfire/auth/LOAD_AUTH_USER";
interface LoadAuthUserAction {
  type: typeof LOAD_AUTH_USER;
}

export const LOAD_AUTH_USER_SUCCESS = "bonfire/auth/LOAD_AUTH_USER_SUCCESS";
interface LoadAuthUserSuccessAction {
  type: typeof LOAD_AUTH_USER_SUCCESS;
  /** NOTE: This is an API response */
  result: Insite.API.User;
}

export const LOAD_AUTH_USER_FAIL = "bonfire/auth/LOAD_AUTH_USER_FAIL";
interface LoadAuthUserFailAction {
  type: typeof LOAD_AUTH_USER_FAIL;
  // TODO: How is this handled?
  error: any;
}

export const LOGIN = "bonfire/auth/LOGIN";
interface LoginAction {
  type: typeof LOGIN;
  username: string;
}

export const LOGIN_SUCCESS = "bonfire/auth/LOGIN_SUCCESS";
interface LoginSuccessAction {
  type: typeof LOGIN_SUCCESS;
  /** NOTE: This is an API response */
  result: {
    token: string;
  };
}

export const LOGIN_FAIL = "bonfire/auth/LOGIN_FAIL";
interface LoginFailAction {
  type: typeof LOGIN_FAIL;
  // TODO: How is this handled?
  error: any;
}

export const LOGOUT = "bonfire/auth/LOGOUT";
interface LogoutAction {
  type: typeof LOGOUT;
}

export const LOGOUT_SUCCESS = "bonfire/auth/LOGOUT_SUCCESS";
interface LogoutSuccessAction {
  type: typeof LOGOUT_SUCCESS;
}

export const LOGOUT_FAIL = "bonfire/auth/LOGOUT_FAIL";
interface LogoutFailAction {
  type: typeof LOGOUT_FAIL;
  // TODO: How is this handled?
  error: any;
}

export const LOGIN_KEYCLOAK = "bonfire/auth/LOGIN_KEYCLOAK";
interface LoginAction_keycloak {
  type: typeof LOGIN_KEYCLOAK;
  username: string;
  token: string;
}

export const LOGOUT_KEYCLOAK = "bonfire/auth/LOGOUT_KEYCLOAK";
interface LogoutAction_keycloak {
  type: typeof LOGOUT_KEYCLOAK;
}

export type AuthAction =
  | LoadAuthUserAction
  | LoadAuthUserFailAction
  | LoadAuthUserSuccessAction
  | LoginAction
  | LoginFailAction
  | LoginSuccessAction
  | LogoutAction
  | LogoutFailAction
  | LogoutSuccessAction
  | LoginAction_keycloak
  | LogoutAction_keycloak
